import BaseService from './_base.service';

const URL = "/appcompany/zone";

// MOBD-98: el mapa operativo (zonas verde/gris/gris plus) para elegir recogida y devolución.
// Es la MISMA fuente que usa la app de usuario, expuesta en el canal de empresa: aquí no hay
// ninguna copia de zonas ni de precios, todo viene del backend.
export const zoneService = {
    mapZones,
    resolve
};

// Zonas activas con su polígono, color y precio, para pintarlas.
// (Se llama mapZones y no map para que no se confunda con Array.prototype.map: el linter avisaba.)
function mapZones(callback) {
    return BaseService.get(URL + "/map", callback, false, false)
}

// En qué zona cae un punto y cuánto cuesta. Devuelve data = null si está FUERA del mapa operativo.
// typeZone: 'RENT_IN' para la recogida, 'RENT_OUT' para la devolución.
function resolve(lat, lng, typeZone, callback) {
    let body = JSON.stringify({ lat, lng, typeZone })
    return BaseService.post(URL + "/resolve", body, callback, true)
}
